import React from 'react'
import './LibraryChapter.css'
import axios from "../../../../axios";
export default function DeletePopup({handleCloseNoteDeltePopup,data,userData,contentId, setComponentRerenderFlag}) {
    const handleDelete=async()=>{
        let res=await axios.delete(`/cm/library/book/deleteUserNotesByUserIDAndContentInfoID?user_id=${userData?.id}&note_id=${data?.id}&contentInfo_id=${contentId}`)
        if(res.status===200){
            // window.location.reload();
            setComponentRerenderFlag((prevFlag) => !prevFlag);
            handleCloseNoteDeltePopup()
        }
    }
    return (
        <div>
            <div className='ContainerDeletePop'>
                <div className='SubContainerDeletePop '>
                    <div className='d-flex justify-content-center deleteMsg'>
                        Are you sure you want to Delete this Note?
                    </div>
                    <div className='d-flex gap-3 mt-3 justify-content-center'>
                        <button className='DeleteYesBtn' onClick={()=>{handleDelete()}}>Yes</button>
                        <button  className='DeleteYesBtn' onClick={()=>{handleCloseNoteDeltePopup()}}>No</button>
                    </div>
                </div>
            </div>
        </div>

    )
}
